import React from "react";
import { AppBar, Badge, Box, Button, Chip, Divider, IconButton, Stack, Toolbar, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import logoSrc from "assets/images/Logo.svg"
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { urlNotifPage, urlTopsPage } from "services/utils/globalVariables";
import { ThreeStarIcon } from "../bottomNavigation/CustomIcon";

export default function TopMenu({ data, loading, setOpenMenu }) {

    const navigate = useNavigate()

    //Navigate to notification page
    const navigateTops = () => {
        navigate(urlTopsPage)
    }

    return (
        <Box sx={{ flexGrow: 1, direction: "ltr !important"}}>
            <AppBar sx={{background: "white !important", height: 60, boxShadow: "0px 4px 20px 0px #0000000D", width: {lg: "400px !important", right: "50% !important", transform: "translateX(50%)"}}} position="fixed">
                <Toolbar sx={{height: "100%"}}>

                    <IconButton aria-label="menu" size="large" onClick={() => setOpenMenu(true)} edge="start" color="primary" sx={{ mr: 1 }}>
                        <MenuIcon />
                    </IconButton>

                    <img style={{width: "107px"}} src={logoSrc} alt="لوگو پاکسرشت هوم" />

                    <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{flexGrow: 1, ml: 2}} component="div" >
                        <Chip
                            icon={<DiamondOutlinedIcon sx={{width: "16px", fontSize: "16px"}} color="primary" />}
                            label={<Typography variant="body2" sx={{color: "#fff", direction: "ltr"}}><b>{loading ? data.Point : "-"}</b> <span style={{marginRight: "0.25rem"}}>امتیاز</span></Typography>}
                            variant="filled"
                            color="secondary"
                            sx={{direction: "rtl", "& .MuiSvgIcon-root": {mr: "5px !important", ml: "-6px !important"}, px: 0.5}}
                        />
                        {
                            data.IsAdmin &&
                            <>
                                <Divider orientation="vertical" sx={{mx: 2}} flexItem />
                                <ThreeStarIcon sx={{width: "24px", fontSize: "24px"}} color="primary" onClick={navigateTops} />
                            </>
                        }
                    </Stack>
                </Toolbar>
            </AppBar>
        </Box>
    )
}